import { User } from '@angular/fire/auth';
import { UserRole } from '@vmspdb/definitions';

export type FirebaseUserRole = keyof typeof UserRole;

export interface FirebaseUser
  extends Omit<
    User,
    'reload' | 'delete' | 'getIdToken' | 'getIdTokenResult' | 'toJSON'
  > {
  internal_id: string;
  role: FirebaseUserRole;
}

export enum AuthStrategies {
  Password = 'password',
  Google = 'google.com',
}
